"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.number.constructor");

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _permission = require("@/mixins/permission/permission");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

var _numberCount = _interopRequireDefault(require("@/components/number-count/number-count.vue"));

var _miniGanttChartV = _interopRequireDefault(require("@/components/mini-gantt-chart-v2/mini-gantt-chart-v2.vue"));

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _mainDashboard = require("./main-dashboard.constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDMainDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDMainDashboardComponent, _Mixins);

  var _super = _createSuper(LMDMainDashboardComponent);

  function LMDMainDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDMainDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.locations = {};
    _this.dashboardData = {};
    _this.routingData = {};
    _this.summaryData = {};
    _this.selectedValues = [];
    _this.selectedLatlng = [];
    _this.ganttDOI = 0;
    _this.ganttDate = null;
    return _this;
  }

  (0, _createClass2.default)(LMDMainDashboardComponent, [{
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileDelivery/planDate'];
    },
    set: function set(newVal) {
      this.$setPlanDate(newVal);
    }
  }, {
    key: "hasAssemblyMinutes",
    get: function get() {
      var hasAssemblyMinute = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity3', default12)) {
        hasAssemblyMinute = true;
      }

      return hasAssemblyMinute;
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.loading = true;
      this.dashboardData = this.helper.cloneDeep(_mainDashboard.DEFAULT_DASHBOARD_DATA);
      this.$setDashboardVehicles([]);

      if (!this.requestLegacy) {
        this.requestLegacy = new _request.Request('application/json', this.$lfToken || null);
      }

      this.locations = {
        'latitude': this.$userData.latlng.split(',')[0],
        'longitude': this.$userData.latlng.split(',')[1]
      };
      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = this.$userInformation.customerKey || '';
      this.updateData();
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "loadCoreInformation",
    value: function loadCoreInformation() {
      var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var promises = [];
      promises.push(this.requestLegacy.get('LEGACY_CORE_V3', 'routeplanning/summary', {
        dataType: 'basic',
        startTime: startDate ? startDate : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 00:00:00'),
        endTime: endDate ? endDate : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 23:59:59')
      }));
      promises.push(this.request.get('ROUTING', "v1/core/lastmile/dashboard?code=".concat(this.$planDate, "&userId=").concat(this.$userInformation.user.id), this.requestParameters));
      return Promise.all(promises);
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this2 = this;

      this.loadCoreInformation().then(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            summary = _ref2[0],
            data = _ref2[1];

        if (data.failed || summary.failed) {
          return Promise.reject('');
        }

        _this2.summaryData = summary.data || {};
        _this2.dashboardData = _this2.helper.get(data, 'data.count', {});
        _this2.dashboardData['assignedOrder'] = _this2.helper.get(data, 'data.routes.assignedOrder', []).length;
        _this2.dashboardData['completedOrder'] = _this2.helper.get(data, 'data.routes.completedOrder', []).length;

        var vehicles = _this2.helper.get(data, 'data.vehicles', []);

        _this2.routingData = {
          code: _this2.$planDate,
          orderId: _this2.helper.flatten(vehicles.map(function (i) {
            return i['orderId'];
          })),
          planId: _this2.helper.flatten(vehicles.map(function (i) {
            return i.planId;
          })),
          truckId: vehicles.map(function (i) {
            return i.truckId;
          }).reverse(),
          data: vehicles
        };
        _this2.loading = false;
      }).catch(function (error) {
        _this2.dashboardData = {};
        _this2.summaryData = {};
        _this2.loading = false;
      });
    }
  }, {
    key: "latLng",
    value: function latLng() {
      if (this.routingData && this.routingData['data'].length >= 1) {
        var fRoutes = this.routingData['data'][0];
        this.selectedValues = fRoutes['truckId'] ? [Number(fRoutes['truckId'])] : [];
      }
    }
  }, {
    key: "updateMarker",
    value: function updateMarker() {
      var _this3 = this;

      var truckIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var index = arguments.length > 1 ? arguments[1] : undefined;
      var markMap = this.$refs.markMap;
      markMap.removeMarker();

      if (this.routingData && this.routingData['data'] && this.routingData['data'].length >= 1 && truckIds && truckIds.length >= 1 && typeof markMap !== 'undefined') {
        truckIds.forEach(function (truckId, truckIdx) {
          var routesList = _this3.routingData['data'].find(function (rData) {
            return rData && rData['routes'] && rData['routes'].length >= 1 && rData['truckId'] && rData['truckId'] === truckId;
          });

          if (routesList) {
            var locationsList = [];
            routesList['routes'].forEach(function (wpData) {
              if (wpData['latitude'] && wpData['longitude']) {
                locationsList.push({
                  'latitude': wpData['latitude'],
                  'longitude': wpData['longitude']
                });
              }
            });

            if (locationsList.length >= 1) {
              markMap.addMarker(locationsList, _this3.getVehicleColor(truckId));
            }
          }
        });
      }
    }
  }, {
    key: "getVehicleColor",
    value: function getVehicleColor(truckId) {
      var color = this.$dashboardVehicles.find(function (vehicle) {
        return vehicle['id'] === truckId;
      });
      return color && color['color'] ? color['color'] : '#387fc2';
    }
  }, {
    key: "handlePlanDateChanges",
    value: function handlePlanDateChanges() {
      this.loading = true;
      this.updateData();
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return LMDMainDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin, _autoLogout.AutoLogoutMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LMDMainDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], LMDMainDashboardComponent.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('dashboardVehicles', {
  namespace: 'common'
})], LMDMainDashboardComponent.prototype, "$dashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DASHBOARD_VEHICLES', {
  namespace: 'common'
})], LMDMainDashboardComponent.prototype, "$setDashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE', {
  namespace: 'lastMileDelivery'
})], LMDMainDashboardComponent.prototype, "$setPlanDate", void 0);
LMDMainDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDMainDashboardComponent',
  components: {
    'number-count': _numberCount.default,
    'mini-gantt-chart': _miniGanttChartV.default,
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-card': _elementUi.Card,
    'el-date-picker': _elementUi.DatePicker
  }
})], LMDMainDashboardComponent);
var _default = LMDMainDashboardComponent;
exports.default = _default;